import React, { useState } from 'react';
import { formatDateTime } from "../../components/DateUtil";

export default function DownloadStatusList({ data }) {
    const DOWNLOADSTATUS_LIST = ["None", "Bill Payment", "Balance Transfer", "History Statement", "E-Banking", "Gateway"]
    const STATUS_LIST = ["None", "In Progress", "Success", "Error"]

    return (
        <>
            <div id="downloadStatusList" className="table-responsive table-hover table-sales text-nowrap">
                <table id="basic-datatables" className="table table-striped table-hover align-items-center mb-0">
                    <thead className="thead-light">
                        <tr>
                            <th scope="col">Date</th>
                            <th scope="col">Bank</th>
                            <th scope="col">Bank No</th>
                            <th scope="col">Type</th>
                            <th scope="col">Status</th>
                            <th scope="col">Remark</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            data?.map((item, index) => {
                                let statusClass = ''
                                if (item.status === 2) statusClass = 'text-success'
                                else if (item.status === 3) statusClass = 'text-danger'

                                return (
                                    <tr key={index}>
                                        <td>{formatDateTime(new Date(item.start_date_time))}</td>
                                        <td>{item.bankabv}</td>
                                        <td>{item.bankno}</td>
                                        <td>{DOWNLOADSTATUS_LIST[item.transtype]}</td>
                                        <td className={statusClass}>{STATUS_LIST[item.status]}</td>
                                        <td className={statusClass}>{item.remark}</td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </table>
            </div>
        </>
    )
}